import _get from "lodash/get";
import styled, { css } from 'styled-components';
import { lighten, transparentize, rem } from 'polished';
import { baseTheme } from '~base-theme';
import { buttonTheme } from '~button';
import { typographyTheme } from '~typography';
import { BUTTON_GROUP_LABEL_MARGIN } from '../constants/formConstants';

var borderRadius = function borderRadius(_ref) {
  var theme = _ref.theme,
      buttonSize = _ref.buttonSize;
  return rem(_get(theme, "button.borderRadius[" + buttonSize + "]", buttonTheme.button.borderRadius[buttonSize]));
};

var FormCheckboxButtonLabel = styled.label.withConfig({
  displayName: "FormCheckboxButtonLabel",
  componentId: "sc-1c9p7he-0"
})(["align-items:center;background-color:transparent;border-color:", ";border-style:solid;border-width:1px;color:", ";cursor:pointer;display:inline-flex;font-family:", ";font-weight:", ";font-size:", ";margin:0;padding-bottom:", ";padding-left:", ";padding-right:", ";padding-top:", ";position:relative;text-align:center;transition:background-color 0.15s ease-in-out,color 0.15s ease-in-out;user-select:none;", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", ""], function (_ref2) {
  var theme = _ref2.theme;
  return _get(theme, 'base.colors.muted', baseTheme.base.colors.muted);
}, function (_ref3) {
  var theme = _ref3.theme;
  return _get(theme, 'base.colors.muted', baseTheme.base.colors.muted);
}, function (_ref4) {
  var theme = _ref4.theme;
  return _get(theme, 'typography.base.fontFamily', typographyTheme.typography.base.fontFamily);
}, function (_ref5) {
  var theme = _ref5.theme;
  return _get(theme, 'button.fontWeight', buttonTheme.button.fontWeight);
}, function (_ref6) {
  var theme = _ref6.theme,
      buttonSize = _ref6.buttonSize;
  return rem(_get(theme, "button.fontSize[" + buttonSize + "]", buttonTheme.button.fontSize[buttonSize]));
}, function (_ref7) {
  var theme = _ref7.theme,
      buttonSize = _ref7.buttonSize;
  return rem(_get(theme, "button.padding[" + buttonSize + "].v", buttonTheme.button.padding[buttonSize].v));
}, function (_ref8) {
  var theme = _ref8.theme,
      buttonSize = _ref8.buttonSize;
  return rem(_get(theme, "button.padding[" + buttonSize + "].h", buttonTheme.button.padding[buttonSize].h));
}, function (_ref9) {
  var theme = _ref9.theme,
      buttonSize = _ref9.buttonSize;
  return rem(_get(theme, "button.padding[" + buttonSize + "].h", buttonTheme.button.padding[buttonSize].h));
}, function (_ref10) {
  var theme = _ref10.theme,
      buttonSize = _ref10.buttonSize;
  return rem(_get(theme, "button.padding[" + buttonSize + "].v", buttonTheme.button.padding[buttonSize].v));
}, function (_ref11) {
  var theme = _ref11.theme,
      checked = _ref11.checked,
      disabledValue = _ref11.disabledValue,
      labelOnly = _ref11.labelOnly;
  return checked === false && disabledValue === false && labelOnly === false && css(["&:hover{border-color:", ";color:", ";}&:focus,&:active{box-shadow:inset 0 3px 5px rgba(0,0,0,0.125);}"], lighten(0.1, _get(theme, 'base.colors.muted', baseTheme.base.colors.muted)), lighten(0.1, _get(theme, 'base.colors.muted', baseTheme.base.colors.muted)));
}, function (_ref12) {
  var theme = _ref12.theme,
      buttonType = _ref12.buttonType;
  return buttonType === 'pointer' && css(["background-color:transparent;border:0;color:", ";cursor:pointer;position:relative;text-transform:uppercase;transition:all 0.3s ease-in-out;&:after{border-left:0 solid transparent;border-right:0 solid transparent;border-top:0 solid transparent;bottom:0;content:'';left:50%;opacity:0;position:absolute;transform:translateX(-50%);transition:opacity 0.3s ease-in-out,bottom 0.3s ease-in-out,border 0.3s ease-in-out;}&:hover{color:", ";}&:focus,&:active{box-shadow:none;}"], _get(theme, 'base.colors.muted', baseTheme.base.colors.muted), lighten(0.1, _get(theme, 'base.colors.muted', baseTheme.base.colors.muted)));
}, function (_ref13) {
  var buttonType = _ref13.buttonType,
      buttonSize = _ref13.buttonSize,
      theme = _ref13.theme;
  return buttonType === 'default' && css(["margin-left:-1px;&:first-of-type{border-bottom-left-radius:", ";border-left-width:1px;border-top-left-radius:", ";margin-left:0;}&:last-of-type{border-bottom-right-radius:", ";border-top-right-radius:", ";}"], borderRadius({
    buttonSize: buttonSize,
    theme: theme
  }), borderRadius({
    buttonSize: buttonSize,
    theme: theme
  }), borderRadius({
    buttonSize: buttonSize,
    theme: theme
  }), borderRadius({
    buttonSize: buttonSize,
    theme: theme
  }));
}, function (_ref14) {
  var buttonType = _ref14.buttonType,
      buttonSize = _ref14.buttonSize,
      theme = _ref14.theme;
  return buttonType === 'pills' && css(["border-radius:", ";margin:", ";"], borderRadius({
    buttonSize: buttonSize,
    theme: theme
  }), rem(BUTTON_GROUP_LABEL_MARGIN));
}, function (_ref15) {
  var theme = _ref15.theme,
      buttonType = _ref15.buttonType,
      buttonSkin = _ref15.buttonSkin,
      buttonSize = _ref15.buttonSize;
  return buttonType === 'bubble' && css(["border-color:", ";border-radius:", ";border-width:2px;color:", ";margin:", ";text-transform:uppercase;&:hover{border-color:", ";color:", ";}"], _get(theme, "button[" + buttonSkin + "].background", buttonTheme.button[buttonSkin].background), borderRadius({
    buttonSize: buttonSize,
    theme: theme
  }), _get(theme, "button[" + buttonSkin + "].background", buttonTheme.button[buttonSkin].background), rem(BUTTON_GROUP_LABEL_MARGIN), lighten(0.1, _get(theme, "button[" + buttonSkin + "].background", buttonTheme.button[buttonSkin].background)), lighten(0.1, _get(theme, "button[" + buttonSkin + "].background", buttonTheme.button[buttonSkin].background)));
}, function (_ref16) {
  var theme = _ref16.theme,
      disabledValue = _ref16.disabledValue,
      buttonType = _ref16.buttonType,
      buttonSkin = _ref16.buttonSkin;
  return disabledValue && buttonType === 'bubble' && css(["border-color:", ";color:", ";cursor:not-allowed;"], lighten(0.2, _get(theme, "button[" + buttonSkin + "].background", buttonTheme.button[buttonSkin].background)), lighten(0.2, _get(theme, "button[" + buttonSkin + "].background", buttonTheme.button[buttonSkin].background)));
}, function (_ref17) {
  var buttonSize = _ref17.buttonSize;
  return buttonSize === 'sm' && css(["font-weight:700;text-transform:uppercase;"]);
}, function (_ref18) {
  var theme = _ref18.theme,
      labelOnly = _ref18.labelOnly,
      checked = _ref18.checked,
      buttonSkin = _ref18.buttonSkin;
  return labelOnly === false && checked && css(["&,&:hover{background-color:", ";border-color:", ";color:", ";}z-index:2;"], _get(theme, "button[" + buttonSkin + "].background", buttonTheme.button[buttonSkin].background), _get(theme, "button[" + buttonSkin + "].background", buttonTheme.button[buttonSkin].background), _get(theme, "button[" + buttonSkin + "].color", buttonTheme.button[buttonSkin].color));
}, function (_ref19) {
  var theme = _ref19.theme,
      buttonType = _ref19.buttonType,
      labelOnly = _ref19.labelOnly,
      checked = _ref19.checked,
      buttonSkin = _ref19.buttonSkin;
  return buttonType === 'pointer' && labelOnly === false && checked && css(["background-color:", ";color:", ";text-decoration:none;&:after{border-left:6px solid transparent;border-right:6px solid transparent;border-top:6px solid ", ";bottom:-6px;opacity:1;}"], _get(theme, "button[" + buttonSkin + "].background", buttonTheme.button[buttonSkin].background), _get(theme, "button[" + buttonSkin + "].color", buttonTheme.button[buttonSkin].color), _get(theme, "button[" + buttonSkin + "].background", buttonTheme.button[buttonSkin].background));
}, function (_ref20) {
  var theme = _ref20.theme,
      disabledValue = _ref20.disabledValue,
      labelOnly = _ref20.labelOnly,
      buttonType = _ref20.buttonType;
  return disabledValue && labelOnly === false && buttonType !== 'bubble' && css(["&,&:hover{border-color:", ";color:", ";}cursor:not-allowed;"], lighten(0.2, _get(theme, 'base.colors.muted', baseTheme.base.colors.muted)), lighten(0.2, _get(theme, 'base.colors.muted', baseTheme.base.colors.muted)));
}, function (_ref21) {
  var theme = _ref21.theme,
      disabledValue = _ref21.disabledValue,
      checked = _ref21.checked,
      labelOnly = _ref21.labelOnly,
      buttonSkin = _ref21.buttonSkin;
  return disabledValue && checked && labelOnly === false && css(["&,&:hover{background-color:", ";border-color:", ";color:", ";}cursor:not-allowed;"], lighten(0.2, _get(theme, "button[" + buttonSkin + "].background", buttonTheme.button[buttonSkin].background)), lighten(0.2, _get(theme, "button[" + buttonSkin + "].background", buttonTheme.button[buttonSkin].background)), lighten(0.1, _get(theme, "button[" + buttonSkin + "].color", buttonTheme.button[buttonSkin].color)));
}, function (_ref22) {
  var theme = _ref22.theme,
      disabledValue = _ref22.disabledValue,
      labelOnly = _ref22.labelOnly,
      checked = _ref22.checked,
      buttonType = _ref22.buttonType,
      buttonSkin = _ref22.buttonSkin;
  return disabledValue && labelOnly === false && checked && buttonType === 'pointer' && css(["&:after{border-left:6px solid transparent;border-right:6px solid transparent;border-top:6px solid ", ";bottom:-6px;opacity:1;}"], lighten(0.2, _get(theme, "button[" + buttonSkin + "].background", buttonTheme.button[buttonSkin].background)));
}, function (_ref23) {
  var theme = _ref23.theme,
      labelOnly = _ref23.labelOnly;
  return labelOnly && css(["&,&:hover{background-color:transparent;border-color:transparent;color:", ";}font-weight:700;text-transform:none;"], _get(theme, 'base.colors.muted', baseTheme.base.colors.muted));
}, function (_ref24) {
  var theme = _ref24.theme,
      labelOnly = _ref24.labelOnly,
      checked = _ref24.checked,
      buttonSkin = _ref24.buttonSkin;
  return labelOnly && checked && css(["&,&:hover{color:", ";}"], _get(theme, "button[" + buttonSkin + "].background", buttonTheme.button[buttonSkin].background));
}, function (_ref25) {
  var theme = _ref25.theme,
      disabledValue = _ref25.disabledValue,
      labelOnly = _ref25.labelOnly;
  return disabledValue && labelOnly && css(["color:", ";cursor:not-allowed;"], lighten(0.2, _get(theme, 'base.colors.muted', baseTheme.base.colors.muted)));
}, function (_ref26) {
  var theme = _ref26.theme,
      disabledValue = _ref26.disabledValue,
      checked = _ref26.checked,
      labelOnly = _ref26.labelOnly,
      buttonSkin = _ref26.buttonSkin;
  return disabledValue && checked && labelOnly && css(["color:", ";"], transparentize(0.2, _get(theme, "button[" + buttonSkin + "].background", buttonTheme.button[buttonSkin].background)));
});
export default FormCheckboxButtonLabel;